import React from 'react';
import styled from 'styled-components';
import { Dropdown } from '../design-system';
import Ellipsis from './Ellipsis';

interface DropdownOption {
  id: string | number;
  onClick?: (...args: any[]) => any;
  render: () => React.ReactNode;
}

interface EllipsisDropdownProps {
  placement?: any;
  options?: DropdownOption[];
}

const LinkDropDownItem = styled(Dropdown.Item)`
  padding: 0;
`;

const EllipsisDropdown = ({ placement, options }: EllipsisDropdownProps) => {
  return (
    <Dropdown placement={placement} width={200} trigger={<Ellipsis />}>
      {options &&
        options.map(({ id, onClick, render }) =>
          onClick ? (
            <Dropdown.Item key={id} onClick={onClick}>
              {render()}
            </Dropdown.Item>
          ) : (
            <LinkDropDownItem key={id}>{render()}</LinkDropDownItem>
          ),
        )}
      <Dropdown.Item id="ellipsis-cancel-button" color="red">
        Cancel
      </Dropdown.Item>
    </Dropdown>
  );
};

export default EllipsisDropdown;
